import React, { useEffect, useState } from 'react';
import { resetEmail } from 'Api/ProfileApi';
import { onSubmitReactFormError } from 'Utils/FormValidation';
import { trackEvent, TRACKING_ENUMS } from 'Utils/Analytics';
import ResetPasswordLayout from 'Features/ResetPassword/ResetPasswordLayout';

const getResetPasswordErrorMessage = (message) => {
  return message.includes('400') ? 'Unable to process your request. Please try again later.' : message;
  //Disabling the hardcoded error message below to assist with troubleshooting incident 3488 bug.
  //Will likely return to hardcoded error message after.
  // : 'This email address is not associated with a Fox Nation subscription.';
};

export const ResetGetEmailContainer = ({ inModal }) => {
  const [userEmail, setUserEmail] = useState('');
  const [resetEmailSuccess, setEmailSuccess] = useState(false);

  useEffect(() => {
    trackEvent(TRACKING_ENUMS.EVENT_FORGOT_PASSWORD_SELECTED);
  }, []);

  const handleSubmit = async ({ email }) => {
    trackEvent(TRACKING_ENUMS.EVENT_PASSWORD_RESET_PROVIDED);
    const reset = await resetEmail(email);

    if (reset === true) {
      setUserEmail(email);
      setEmailSuccess(true);
      trackEvent(TRACKING_ENUMS.EVENT_PASSWORD_RESET_COMPLETED);
    } else {
      const errorText = getResetPasswordErrorMessage(reset);
      return onSubmitReactFormError(errorText);
    }
  };

  return (
    <ResetPasswordLayout
      resetEmailSuccess={resetEmailSuccess}
      inModal={inModal}
      onSubmit={handleSubmit}
      resetEmail={userEmail}
    />
  );
};
